angular.module('jv.Dashboard.My.Referrals.Controller', [])
.controller('jv.Dashboard.My.Referrals.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs','$rootScope', 'TemplateLoader','$sce','$filter',

    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, TemplateLoader,$sce, $filter){
        $scope.refreshTimestamp = true;
        //Handler for refresh_widget
        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                init();
                $scope.refreshTimestamp = false;
                $scope.fetchReferrals(0);
            }
        });

        $scope.pageSize = 5;
        $scope.totalCount = 0;
        $scope.currentPage = 0;
        $scope.duration = 0;

        var init = function(){
            var widgetSettings = $scope.widgetObject.userWidgetSettings.widgetSetting;
            angular.forEach(widgetSettings, function(widgetSetting, index){
                var settingObject;
                if (widgetSetting.userValues) {
                    settingObject = widgetSetting.userValues[0];
                } else {
                    if(widgetSetting.settings.defaultValues){
                        settingObject = widgetSetting.settings.defaultValues[0];
                    }
                }
                switch(widgetSetting.settings.name) {
                case 'Duration':
                    $scope.duration = settingObject.value;
                    break;
                default:
                    break;
                }
            });
        };

        $scope.fetchReferrals = function(pageNumber){
            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            $scope.currentPage = pageNumber;
            var todaysDate = $rootScope.fetchTodayInUsersTimeZone();
            var postData = {
                'page': pageNumber,
                'pageSize': 5,
                'startDate' : moment(todaysDate).subtract($scope.duration,'days').format('MM/DD/YYYY'),
                'endDate' : $filter('date')(todaysDate, 'MM/dd/yyyy')
            };
            jvDashboardAjaxService.getReferrals(postData,function(response){
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.refreshTimestamp = true;
                if(response && response.resultList){
                    $scope.totalCount = response.resultCount;
                    $scope.referrals = response.resultList;
                    angular.forEach($scope.referrals,function(referral,key){
                        //TODO: JobseekerPhoto Refactor.
                        var firstInitial = referral.firstName && referral.firstName.match(/^[a-z]/i) ? referral.firstName.charAt(0).toUpperCase() : '';
                        var lastInitial = referral.lastName && referral.lastName.match(/^[a-z]/i) ? referral.lastName.charAt(0).toUpperCase() : '';
                        var profilePicUrl =  $window.jvUrls.cdn + 'thumbnails/avatar/'+ firstInitial + lastInitial + '-default.png';
                        if (!firstInitial && !lastInitial) {
                            profilePicUrl = $window.jvUrls.cdn + 'images/icon-profilePic_l.png';
                        }

                        referral.profilePicUrl =  $sce.trustAsResourceUrl(profilePicUrl);
                        referral.allApplications[0].showJoblink = true;
                        if(!referral.allApplications[0].jobTitle){
                            referral.allApplications[0].jobTitle  = i18n['GENERAL_APPLICATION'];
                            referral.allApplications[0].showJoblink = false;
                        }
                    });
                } else {
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        };
        init();
        $scope.fetchReferrals(0);
}]);
